import React, { useState, useRef, useEffect, Fragment } from "react";
import moment from 'moment';
import isLoggedIn from "../../../components/isLoggedIn";
import CloseX from "../../icons/CloseX";
import { ON_CELLS_PROCESSED } from "../../globals";

const VariationCell = (props) => {
  const [focused, setFocused] = useState(false);
  const [showBackorder, setShowBackorder] = useState(false);

  const {
    etdMode
  }= props;

  const [quantity, setQuantity] = useState(props.quantity);
  const displayQuantity = quantity > 0 ? quantity : props.quantity || '';
  const inputRef = useRef();

  const updateQuantity = (e) => {
    let qty = e.target.value ? parseInt(e.target.value) : 0;
    if (qty < 0) {
      qty = 0;
    }

    if (isNaN(qty)) {
      qty = 0;
    }
    setQuantity(qty);
    setShowBackorder(qty > props.variation.stock);
    props.updateVariationQuantity(props.variation, qty);
  };

  const blur = () => {
    if (!quantity) {
      setFocused(false);
    }
  };

  const focus = () => {
    if (props.variation.can_purchase && isLoggedIn()) {
      setFocused(true);
      setTimeout(() => {
        inputRef.current.focus();
      }, 5);
    }
  };


  useEffect(() => {
    if (showBackorder) {
      const timeoutId = setTimeout(() => {
        setShowBackorder(false);
      }, 5000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [showBackorder]);

  useEffect(() => {
    const handleCellsProcessed = () => {
      setQuantity(0);
      props.updateVariationQuantity(props.variation, 0);
    };

    window.addEventListener(ON_CELLS_PROCESSED, handleCellsProcessed);

    return () => {
      window.removeEventListener(ON_CELLS_PROCESSED, handleCellsProcessed);
    };
  }, [props.variation, props.parent]);

  const variation = props.variation;
  const loggedIn = isLoggedIn();
  if (!variation.can_purchase) {
    return <div className={'grayed-out'}></div>;
  }

  return <>
    {!!showBackorder && (
      <div className={'backorder'} style={{position:'absolute' }}>
        <div className={'backorder__close'} onClick={() => setShowBackorder(false)}>
          <CloseX />
        </div>
        <div className={'backorder__inner'}>{variation.full_stock} in stock. Balance will be backordered.</div>
      </div>
    )}
    <div
      className={`cell summary-table__cell ${displayQuantity > 0 ? 'cell--filled' : ''}`}
      tabIndex={props.tabIndex}
      onClick={focus}>

      {variation.can_purchase && <input
        className={`${displayQuantity > 0 ? 'active' : ''}`}
        type={'text'}
        ref={inputRef}
        onBlur={blur}
        value={displayQuantity}
        disabled={!loggedIn && !variation?.enabled_retail_order}
        data-i={variation.id}
        onKeyDown={(e) => {
          if (e.code === 'Enter') {
            props.addGroupToCart(e);
          }
        }}
        onChange={(e) => {
          e.preventDefault();
          updateQuantity(e);
          return false;
        }}
      />}

      <span className={`${quantity > 0 ? 'entered-stock' : ''} stock`}>{variation.stock}</span>
      {(variation.new_etd && etdMode) && <span className={'etd'}>{moment(variation.new_etd).format('DD MMM')}</span>}
    </div>

  </>
};

export default VariationCell;
